(() => {
  return;

  // eslint-disable-next-line no-unreachable
  const wait = (seconds) => new Promise((resolve) => {
    window.setTimeout(() => {
      resolve();
    }, seconds * 1000);
  });

  // eslint-disable-next-line no-unreachable
  window.swinger.observer.initialize('.swinger-mixed-results--is-error-page', () => {
    Promise.all([
      window.swinger.i18n(),
      wait(3),
    ])
      .then((results) => {
        const { 0: i18n } = results;

        window.swinger.snackbar.create({
          children: [
            {
              component: 'notification',
              data: {
                type: 'error',
                text: i18n('ui.client-error.notification.text'),
              },
            },
          ],
        });
      })
      .catch(console.info);
  });
})();
